import { Chat } from '@/features/account/components/Chat'
import { type CMSPageDataWithSpecificLayout } from '@/features/cms/components/CMS/types'
import { GapManager } from '@/features/cms/components/CMS/components/GapManager'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { CMSSection } from '@/features/cms/components/CMS/CMSSection'
import { Footer } from '@/features/shared/components/Footers/Footer'

/**
 * This component corresponds to the `page_layout` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/page_layout
 * - **Production** - https://cms.shipt.com/content-type/pool/page_layout
 */
export const PageLayout = ({
  layoutData: { id, content_type_id, data },
  hideChat,
}: {
  layoutData: CMSPageDataWithSpecificLayout<'page_layout'>['content']
  hideChat?: boolean
}) => (
  <div {...getCMSWrapperProps({ content_type_id, id })}>
    {!!data.announcement && <CMSSection section={data.announcement} />}
    {!!data.header && <CMSSection section={data.header} />}
    {!!data.body && (
      <GapManager
        verticalSpacing={data.vertical_spacing}
        mobileVerticalSpacing={data.mobile_web_vertical_spacing}
      >
        <CMSSection section={data.body} />
      </GapManager>
    )}
    {data.footer ? <CMSSection section={data.footer} /> : <Footer />}
    {!hideChat && <Chat />}
  </div>
)
